import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { donorProposalEmailCompleted } from "../../features/projectsSlice";
import { FilePenLine } from "lucide-react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../components/notification/NotificationContainer";
import { closeModal } from "../../features/modalSLice";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";

const ContactDonorCompleted = ({ id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addNotification = useNotification();
  const { handleSubmit } = useForm();
  const loading = useSelector(
    (state) => state.projects.load.donorProposalEmailCompleted
  );

  //When done Mailing or recording
  const onSubmit = async () => {
    try {
      const res = await dispatch(donorProposalEmailCompleted(id));
      if (donorProposalEmailCompleted.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification("Email Sending Completed", "success");
        navigate(-1);
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  return (
    <div className="min-w-[85vw] sm:min-w-[30rem]  max-w-[30rem] text-text-1/80">
      <div className="flex  justify-right items-center gap-2 py-3 border-b border-bkg2 mb-4 text-text-1/80">
        <FilePenLine />
        <h4> Confirmation </h4>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <p className="text-lg text-wrap">
            Are you sure you want to continue to donor follow up and have
            contacted all the neccessary donor?
          </p>
        </div>
        <ResourseButtons loading={loading} submitText="Continue" />
      </form>
    </div>
  );
};

export default ContactDonorCompleted;
